import axios from 'axios';

//const API = axios.create({ baseURL: 'http://localhost:5000' });
const API = axios.create({ baseURL: 'https://blendblog.herokuapp.com/' });

API.interceptors.request.use((req) => {
  if (localStorage.getItem('profile')) {
    req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;
  }

  return req;
});


export const fetchAllpdfs = () => API.get(`/posts/pdfs`);
export const addnewReasources = (newPost) => API.post('/posts/addpdf', newPost);
export const deletePdf = (id) => API.delete(`/posts/pdfs/delete/${id}`);

export const getIndividulaContributionById = (id)=>API.get(`/posts/getbyId/${id}`)
export const fetchPost = (id) => API.get(`/posts/${id}`);
export const fetchContributionByPostId = (id) => API.get(`/posts/contributedpost/${id}`);
export const fetchPosts = (page) => API.get(`/posts?page=${page}`);
export const fetchPostsBySearch = (searchQuery) => API.get(`/posts/search?searchQuery=${searchQuery.search || 'none'}&tags=${searchQuery.tags}`);
export const createPost = (newPost) => API.post('/posts', newPost);
export const likePost = (id) => API.patch(`/posts/${id}/likePost`);
export const updatePost = (id, updatedPost) => API.patch(`/posts/${id}`, updatedPost);

export const updateContribute = (id, updatedPost) => API.patch(`/posts/contribute/${id}`, updatedPost);
export const deletePost = (id) => API.delete(`/posts/${id}`);
export const comment = (value, id) => API.post(`/posts/${id}/commentPost`, { value });

export const signIn = (formData) => API.post('/user/signin', formData);
export const signUp = (formData) => API.post('/user/signup', formData);
export const getUsersById = (id) => API.get(`/profile/${id}`);
export const fetchSingleUserPosts = (id) => API.get(`/posts/single/${id}`);
export const updateUserProfile = (id, userData) => API.patch(`/user/update/${id}`, userData);